// @core/api/endpoints/notifications/create_notification_scheduled.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateNotificationScheduledRequest,
  CreateNotificationScheduledResponse,
} from '../../../types/notifications';

const BASE_PATH = '/notifications';

/**
 * Create scheduled notification
 * Schedules a notification to be sent at a specified future time. The notification will be queued and automatically delivered when the scheduled time arrives.
 */
export async function CreateNotificationScheduled(
  data: CreateNotificationScheduledRequest,
  options?: RequestOptions
): Promise<CreateNotificationScheduledResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/notifications/scheduled`;
  const requestOptions = options;
  return client.post<CreateNotificationScheduledResponse>(requestPath, data, requestOptions);
}
